<script setup lang="ts">
  interface Emits {
    (event: "update:selectedItem", id: string | null): void;
  }
  interface Props {
    selectedItem: string | null;
    label?: string;
    choices: any[];
    readonly?: boolean;
    itemTitle?: string;
    itemValue?: string;
    rules?: (() => any)[];
    errorMessages?: string[];
    disabled?: boolean;
    placeholder?: string;
    bgColor?: string;
  }
  const props = withDefaults(defineProps<Props>(), {
    label: undefined,
    readonly: false,
    itemTitle: undefined,
    itemValue: undefined,
    rules: () => [],
    errorMessages: () => [],
    disabled: false,
    placeholder: undefined,
    bgColor: "",
  });
  const emit = defineEmits<Emits>();
  const computedData = computed<string | null>({
    get: () => props.selectedItem,
    set: value => {
      emit("update:selectedItem", value);
    },
  });
</script>

<template>
  <div class="inputSelect">
    <v-select
      v-model="computedData"
      :label="label"
      :items="choices"
      :readonly="readonly"
      :item-title="itemTitle"
      :item-value="itemValue"
      :rules="rules"
      :error-messages="errorMessages"
      :disabled="disabled"
      :bg-color="bgColor"
      :placeholder="placeholder"
    >
      <template #label>
        <div class="label">{{ label }}</div>
      </template>
      <template #item="{ props: itemProps, item }">
        <v-list-item v-bind="itemProps" :class="{ 'bg-white': bgColor == 'white' }">
          <template #title>
            <div class="wrap-text">{{ item.title }}</div>
          </template>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<style lang="scss" scoped>
  .wrap-text {
    white-space: normal;
    word-break: break-word;
  }
  .label {
    font-size: 14px;
    letter-spacing: 0.06em;
  }
</style>
